import React from "react";
import PropTypes from "prop-types";

export const FormField = ({
  id,
  type = "text",
  label,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  autoComplete = "off",
  error = false,
  className = "",
}) => {
  return (
    <div className="flex flex-col gap-2 items-start w-full">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        htmlFor={id}
        className="text-sm font-normal leading-none login-text-foreground font-inter"
      >
        {label}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`w-full login-input login-text-muted font-inter ${
          error ? "border-red-500" : ""
        } ${className}`}
        disabled={disabled}
        required={required}
        autoComplete={autoComplete}
      />
    </div>
  );
};

FormField.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  autoComplete: PropTypes.string,
  error: PropTypes.bool,
  className: PropTypes.string,
};

FormField.defaultProps = {
  type: "text",
  placeholder: "",
  disabled: false,
  required: false,
  autoComplete: "off",
  error: false,
  className: "",
};

